import { render, staticRenderFns } from "./IndexDoRoom.vue?vue&type=template&id=374ed811&scoped=true"
import script from "./IndexDoRoom.vue?vue&type=script&lang=js"
export * from "./IndexDoRoom.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "374ed811",
  null
  
)

export default component.exports